module.exports = __webpack_public_path__ + "img/Gallery_1_12.2d0aa57d.jpeg";